import { combineReducers } from 'redux';
import { handleActions, combineActions } from 'redux-actions';
import * as actionTypes from './constants';
import settingsConfig from '../../settings-config';

export const isLoadingPlants = handleActions(
  {
    [combineActions(
      actionTypes.FETCH_WORKING_PLANTS_SUCCESS,
      actionTypes.FETCH_WORKING_PLANTS_FAILURE,
    )]: () => false,
    [combineActions(
      actionTypes.FETCH_WORKING_PLANTS_REQUEST,
    )]: () => true,
  },
  false,
);

export const plants = handleActions(
  {
    [combineActions(
      actionTypes.FETCH_WORKING_PLANTS_REQUEST,
      actionTypes.FETCH_WORKING_PLANTS_FAILURE,
    )]: () => [],
    [actionTypes.FETCH_WORKING_PLANTS_SUCCESS]: (state, { payload }) => payload.items,
  },
  [],
);

export const data = handleActions(
  {
    [combineActions(
      actionTypes.FETCH_WORKING_HOURS_REQUEST,
      actionTypes.FETCH_WORKING_HOURS_FAILURE,
    )]: (state, { payload }) => payload.hideLoadingSpinner ? state : {},
    [combineActions(
      actionTypes.FETCH_WORKING_HOURS_SUCCESS,
      actionTypes.UPDATE_WORKING_HOURS_SUCCESS,
      actionTypes.RESTORE_WORKING_HOURS_SUCCESS,
    )]: (state, { payload }) => payload,
    [actionTypes.SET_DEFAULT_WORKING_HOURS]: (state, { payload }) => ({
      ...settingsConfig.defaultWorkingHours,
      items: settingsConfig.defaultWorkingHours.items?.map(i => ({
        ...i,
        resourceId: payload.resourceId,
      })),
      isDefault: true,
    }),
  },
  {},
);

export const isLoading = handleActions(
  {
    [combineActions(
      actionTypes.FETCH_WORKING_HOURS_SUCCESS,
      actionTypes.FETCH_WORKING_HOURS_FAILURE,
      actionTypes.UPDATE_WORKING_HOURS_SUCCESS,
      actionTypes.UPDATE_WORKING_HOURS_FAILURE,
    )]: () => false,
    [combineActions(
      actionTypes.FETCH_WORKING_HOURS_REQUEST,
      actionTypes.UPDATE_WORKING_HOURS_REQUEST,
    )]: (state, { payload }) => !payload.hideLoadingSpinner,
  },
  false,
);

export const isRestoring = handleActions(
  {
    [combineActions(
      actionTypes.RESTORE_WORKING_HOURS_SUCCESS,
      actionTypes.RESTORE_WORKING_HOURS_FAILURE,
    )]: () => false,
    [combineActions(
      actionTypes.RESTORE_WORKING_HOURS_REQUEST,
    )]: () => true,
  },
  false,
);

export const isFetching = handleActions(
  {
    [combineActions(
      actionTypes.FETCH_WORKING_HOURS_SUCCESS,
      actionTypes.FETCH_WORKING_HOURS_FAILURE,
    )]: () => false,
    [combineActions(
      actionTypes.FETCH_WORKING_HOURS_REQUEST,
    )]: (state, { payload }) => !payload.hideLoadingSpinner,
  },
  false,
);

export const updateSuccess = handleActions(
  {
    [combineActions(
      'LOCATION_CHANGE',
      actionTypes.FETCH_WORKING_HOURS_REQUEST,
      actionTypes.UPDATE_WORKING_HOURS_REQUEST,
      actionTypes.UPDATE_WORKING_HOURS_FAILURE,
    )]: () => false,
    [combineActions(
      actionTypes.UPDATE_WORKING_HOURS_SUCCESS,
    )]: () => true,
  },
  false,
);

export const error = handleActions(
  {
    [combineActions(
      'LOCATION_CHANGE',
      actionTypes.FETCH_WORKING_PLANTS_REQUEST,
      actionTypes.FETCH_WORKING_PLANTS_SUCCESS,
      actionTypes.FETCH_WORKING_HOURS_REQUEST,
      actionTypes.FETCH_WORKING_HOURS_SUCCESS,
      actionTypes.UPDATE_WORKING_HOURS_REQUEST,
      actionTypes.UPDATE_WORKING_HOURS_SUCCESS,
      actionTypes.RESTORE_WORKING_HOURS_REQUEST,
      actionTypes.RESTORE_WORKING_HOURS_SUCCESS,
    )]: () => ({}),
    [combineActions(
      actionTypes.FETCH_WORKING_PLANTS_FAILURE,
      actionTypes.FETCH_WORKING_HOURS_FAILURE,
      actionTypes.UPDATE_WORKING_HOURS_FAILURE,
      actionTypes.RESTORE_WORKING_HOURS_FAILURE,
    )]: (state, { payload }) => payload.error,
  },
  {},
);

export default combineReducers({
  plants,
  isLoadingPlants,
  data,
  error,
  updateSuccess,
  isLoading,
  isFetching,
  isRestoring,
});
